<template>
    <v-container fluid :class="$vuetify.breakpoint.smAndDown ? 'pa-0' : ''">
        <v-card
            :rounded="$vuetify.breakpoint.smAndDown ? '0' : '10'"
            width="100%"
        >
            <v-card-title primary-title>
                <v-row justify="space-between">
                    <v-col cols="10">
                        <div
                            v-if="$vuetify.breakpoint.xs"
                            class="primary--text text-overline ml-2 d-flex"
                        >
                            Reporte comercial
                            <a href="#finReportTable">
                                <v-icon color="primary" right
                                    >mdi-arrow-down-drop-circle</v-icon
                                >
                            </a>
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            <div class="d-flex align-center">
                                <v-icon color="primary" left x-large>
                                    mdi-table-account
                                </v-icon>
                                Reporte comercial
                            </div>
                            <small class="grey--text d-flex justify-start">
                                {{ date }}</small
                            >
                        </div>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end align-center">
                        <v-dialog
                            v-if="KPIs.length"
                            v-model="dialog"
                            width="500"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="red lighten-2 mr-12"
                                    dark
                                    depressed
                                    :x-small="$vuetify.breakpoint.xs"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon> mdi-apple-keyboard-option </v-icon>
                                    {{
                                        $vuetify.breakpoint.xs
                                            ? ''
                                            : 'Parametros'
                                    }}
                                </v-btn>
                            </template>

                            <v-card>
                                <v-card-title class="d-flex">
                                    <div
                                        v-if="$vuetify.breakpoint.xs"
                                        class="primary--text text-overline ml-2"
                                    >
                                        <v-icon left> mdi-pencil </v-icon>
                                        Parametros a mostrar
                                    </div>
                                    <div
                                        v-else
                                        class="
                                            font-weight-light
                                            primary--text
                                            text-h4
                                            ml-2
                                        "
                                    >
                                        <v-icon large left> mdi-pencil </v-icon>
                                        Parametros a mostrar
                                    </div>
                                </v-card-title>
                                <!-- <v-divider class="test"></v-divider> -->
                                <v-card-text class="mt-2 pb-0">
                                    <v-list dense>
                                        <v-list-item
                                            v-for="(value, key) in view"
                                            :key="key"
                                        >
                                            <v-checkbox
                                                class="pa-0 ma-0"
                                                :label="value.text"
                                                v-model="value.value"
                                            ></v-checkbox>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions class="mx-2">
                                    <v-btn
                                        color="red"
                                        text
                                        @click="dialog = false"
                                    >
                                        Cerrar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <Dial />
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                id="reportTable"
                :headers="headers.filter(({ show }) => show)"
                :loading="
                    isLoadingObjetivos || isloadingRewards || isLoadingInfo
                "
                :items="objetivosProcess"
                :footer-props="footerProps"
                :items-per-page="objetivosProcess.length"
                :search="search"
                :custom-sort="customSort"
                disable-pagination
            >
                <template v-slot:item.comercial.nombreCompleto="{ item }">
                    <div
                        :style="
                            $vuetify.breakpoint.xs
                                ? ''
                                : 'width: 200px !important'
                        "
                    >
                        {{ item.comercial.nombreCompleto }}
                    </div>
                </template>
                <template v-slot:item.params="{ item }">
                    <div v-for="(value, key) in view" :key="key">
                        <div v-if="value.value" class="py-2">
                            {{ value.visualize }}
                        </div>
                    </div>
                </template>
                <template
                    v-for="(slot, i) in KPIs"
                    v-slot:[`item.${slot}`]="{ item }"
                >
                    <td
                        :class="`py-2 ${itemRowBackgroundFivePercent(
                            item[slot],
                            calculatePercentageError
                        )}`"
                        :key="i"
                        v-if="item[slot]"
                    >
                        <v-row
                            no-gutters
                            v-if="view.viewPeso.value"
                            class="d-flex justify-center align-center"
                        >
                            <v-col
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'center'
                                        : 'text-center'
                                "
                            >
                                <v-chip color="primary">
                                    {{
                                        `${parseToFloatSpecialInteger(
                                            item[slot].peso
                                        )}%`
                                    }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row
                            no-gutters
                            v-if="view.viewObjCons.value"
                            class="d-flex justify-center align-center mt-1"
                        >
                            <v-col
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'center'
                                        : 'text-center'
                                "
                            >
                                <v-chip
                                    >{{ `${item[slot].objetivo}` }} /
                                    {{ `${item[slot].consecucion}` }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row
                            no-gutters
                            v-if="view.viewObjConsPer.value"
                            class="d-flex justify-center align-center mt-1"
                        >
                            <v-col
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'center'
                                        : 'text-center'
                                "
                            >
                                <v-chip>
                                    {{
                                        item[slot].objetivo_porc
                                            ? `${item[slot].objetivo_porc}% `
                                            : '- '
                                    }}/
                                    {{
                                        item[slot].comision_porc
                                            ? `${item[slot].comision_porc}%`
                                            : '-'
                                    }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row
                            no-gutters
                            v-if="view.viewFivePercent.value"
                            class="d-flex justify-center align-center mt-1"
                        >
                            <v-col
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'center'
                                        : 'text-center'
                                "
                            >
                                <v-chip>
                                    {{
                                        item[slot].five_percent == -1
                                            ? '-'
                                            : `${Math.round(
                                                  item[slot].five_percent
                                              )}`
                                    }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </td>
                </template>
                <template v-slot:item.obj_consec_proyec="{ item }">
                    <td
                        :class="`${itemRowBackgroundFivePercent(
                            item,
                            calculatePercentageErrorTotales
                        )}`"
                    >
                        <v-row
                            no-gutters
                            class="d-flex justify-center align-center mt-1"
                        >
                            <v-col
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'center'
                                        : 'text-center'
                                "
                            >
                                <v-chip>
                                    {{ item.objetivos }}/
                                    {{ item.consecuciones }}/
                                    {{ item.five_percents }}
                                </v-chip>
                            </v-col>
                        </v-row>
                    </td>
                </template>
                <template v-slot:item.consec_total_percent="{ item }">
                    <div>{{ item.consec_total_percent }}%</div>
                </template>
                <template v-slot:item.bolsa="{ item }">
                    <div class="d-flex justify-center">
                        <v-icon
                            small
                            left
                            color="red"
                            v-if="!getReward(item.comercial.id).reward"
                            >mdi-circle</v-icon
                        >
                        <div
                            v-if="
                                getReward(item.comercial.id) && getReward(
                                    item.comercial.id
                                ).reward &&
                                getReward(item.comercial.id).reward.rewardType ==
                                    'BOLSA_FIJA'
                            "
                        >
                            {{ `${getReward(item.comercial.id).reward.amount}€`
                            }}<br />
                            {{ `${getBolsa(item.comercial.id)}€` }}
                        </div>
                        <div v-else>
                            {{ `${getBolsa(item.comercial.id)}€` }}
                        </div>
                    </div>
                </template>
                <template v-slot:item.bolsa_proyeccion="{ item }">
                    <div
                        v-if="
                            getReward(item.comercial.id) &&
                            getReward(item.comercial.id).rewardType ==
                                'BOLSA_FIJA'
                        "
                    >
                        {{ `${getReward(item.comercial.id).amount}€` }}<br />
                        {{ `${getProyeccion(item.comercial.id)}€` }}
                    </div>
                    <div v-else>
                        {{ `${getProyeccion(item.comercial.id)}€` }}
                    </div>
                </template>
                <template v-slot:item.rentabilidad="{ item }">
                    <td :class="rentabilidad(item) <= 0 ? 'rojo text-center' : 'verde text-center'">
                        {{
                            parseToFloatSpecialInteger(
                                item.comercial.costoGeneral
                            )
                        }}€ <br />
                        {{ rentabilidad(item) }}€
                    </td>
                </template>
                <template
                    v-if="comercialesInfo.length"
                    v-slot:item.ofertas="{ item }"
                >
                    {{
                        getXPropComercial(item, 'num_ofertas')
                    }}
                </template>
                <template slot="body.append">
                    <v-data-table
                        v-if="$vuetify.breakpoint.xs && objetivosProcess.length"
                        :headers="headers.filter(({ show }) => show)"
                        :items="[totalesResumen]"
                        disable-sort
                        hide-default-footer
                    >
                        <template v-slot:item.comercial.nombreCompleto>
                            <h2>Total</h2>
                        </template>

                        <template v-slot:item.params>
                            <div v-for="(value, key) in view" :key="key">
                                <div v-if="value.value" class="py-2">
                                    {{ value.visualize }}
                                </div>
                            </div>
                        </template>

                        <template
                            v-for="(slot, i) in KPIs"
                            v-slot:[`item.${slot}`]="{ item }"
                        >
                            <td :class="`py-2 ${itemRowBackgroundFivePercent(
                            totalesResumen.objetivosTotales[slot],
                            calculatePercentageError
                        )}`" :key="i">
                                <v-row
                                    no-gutters
                                    class="
                                        d-flex
                                        justify-center
                                        align-center
                                        mt-1
                                    "
                                >
                                    <v-col
                                        :class="
                                            $vuetify.breakpoint.xs
                                                ? 'text-end'
                                                : 'text-center'
                                        "
                                    >
                                        <v-chip
                                            >{{
                                                `${totalesResumen.objetivosTotales[slot].objetivo}`
                                            }}
                                            /
                                            {{
                                                `${totalesResumen.objetivosTotales[slot].consecucion}`
                                            }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row
                                    no-gutters
                                    class="
                                        d-flex
                                        justify-center
                                        align-center
                                        mt-1
                                    "
                                >
                                    <v-col
                                        :class="
                                            $vuetify.breakpoint.xs
                                                ? 'text-end'
                                                : 'text-center'
                                        "
                                    >
                                        <v-chip
                                            >{{
                                                `${totalesResumen.objetivosTotales[slot].five_percent}`
                                            }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </td>
                        </template>
                        <template v-slot:item.obj_consec_proyec="{ item }">
                            <td :class="`${itemRowBackgroundFivePercent(
                            totalesResumen,
                            calculatePercentageErrorTotales
                            )}`">
                            <v-row
                                no-gutters
                                class="d-flex justify-center align-center mt-1"
                            >
                                <v-col
                                    :class="
                                        $vuetify.breakpoint.xs
                                            ? 'text-end'
                                            : 'text-center'
                                    "
                                >
                                    <v-chip
                                        >{{ `${totalesResumen.objetivos}` }}
                                        /
                                        {{ `${totalesResumen.consecuciones}` }}
                                        /
                                        {{ `${totalesResumen.five_percents}` }}
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </td>
                            
                        </template>
                        <template v-slot:item.consec_total_percent="{ item }">
                            <div>{{ totalesResumen.consecTotalPercent }}%</div>
                        </template>
                        <template v-slot:item.bolsa>
                            {{ totalesResumen.bolsaTotal }}€
                        </template>
                        <template v-slot:item.bolsa_proyeccion>
                            {{ totalesResumen.bolsaTotalPercent }}€
                        </template>
                        <template v-slot:item.rentabilidad>
                            <td :class="totalesResumen.rentabilidad < 0 ? 'rojo' : 'verde'">
                                
                            {{ totalesResumen.rentabilidad }}€
                            </td>
                        </template>
                        <template v-slot:item.ofertas>
                            {{ totalesResumen.numOfertas }}
                        </template>
                    </v-data-table>
                    <tr v-else-if="objetivosProcess.length">
                        <th
                            v-if="isShowValueHeader('comercial.nombreCompleto')"
                        >
                            <h2>Total</h2>
                        </th>
                        <th 
                            v-if="isShowValueHeader('params')"
                        >
                            <div class="py-2">Obj/Cons</div>
                            <div class="py-2">Proyección</div>
                        </th>
                        <th
                         class="px-0"
                            v-for="(slot, i) in onlyKPIinHeaderVisible"
                            :key="i"
                        >
                                <td
                                v-if="isShowValueHeader(slot)"
                                    :class="
                                        `d-block align-center justify-center pa-0 mt-n1 ${itemRowBackgroundFivePercent(
                                            totalesResumen.objetivosTotales[
                                                slot
                                            ],
                                            calculatePercentageError
                                        )}`
                                    "
                                >
                                    <v-row
                                        no-gutters
                                        class="
                                            d-flex
                                            justify-center
                                            align-center
                                            mt-1
                                        "
                                    >
                                        <v-col class="text-center">
                                            <v-chip
                                                >{{
                                                    `${totalesResumen.objetivosTotales[slot].objetivo}`
                                                }}
                                                /
                                                {{
                                                    `${totalesResumen.objetivosTotales[slot].consecucion}`
                                                }}
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="
                                            d-flex
                                            justify-center
                                            align-center
                                            mt-1
                                        "
                                    >
                                        <v-col class="text-center">
                                            <v-chip
                                                >{{
                                                    `${totalesResumen.objetivosTotales[slot].five_percent}`
                                                }}
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                </td>
                        </th>
                        <th
                            v-if="isShowValueHeader('obj_consec_proyec')"
                            :class="`text-center px-0 ${itemRowBackgroundFivePercent(
                                            totalesResumen,
                                            calculatePercentageErrorTotales
                                        )}`">
                                <v-row
                                    no-gutters
                                    class="d-flex justify-center align-center mt-1"
                                >
                                    <v-col
                                        :class="
                                            $vuetify.breakpoint.xs
                                                ? 'text-end'
                                                : 'text-center'
                                        "
                                    >
                                        <v-chip
                                            >{{ `${totalesResumen.objetivos}` }}
                                            /
                                            {{ `${totalesResumen.consecuciones}` }}
                                            /
                                            {{ `${totalesResumen.five_percents}` }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                        </th>
                        <th
                            v-if="isShowValueHeader('consec_total_percent')"
                            class="text-center"
                        >
                            <h2>{{ totalesResumen.consecTotalPercent }}%</h2>
                        </th>
                        <th
                            v-if="isShowValueHeader('bolsa')"
                            class="text-center"
                        >
                            <h2>{{ totalesResumen.bolsaTotal }}€</h2>
                        </th>
                        <th
                            v-if="isShowValueHeader('bolsa_proyeccion')"
                            class="text-center"
                        >
                            <h2>{{ totalesResumen.bolsaTotalPercent }}€</h2>
                        </th>
                        <th
                            v-if="isShowValueHeader('rentabilidad')"
                            :class="`text-center ${totalesResumen.rentabilidad < 0 ? 'rojo': 'verde'}`"
                        >
                            <h2>{{ totalesResumen.rentabilidad }}€</h2>
                        </th>
                        <th
                            v-if="isShowValueHeader('ofertas')"
                            class="text-center"
                        >
                            <h2>{{ totalesResumen.numOfertas }}</h2>
                        </th>
                    </tr>
                </template>
            </v-data-table>
            <DateFilterDialog @dateEvent="onClickChild($event)" />
            <Legend :items="legend" />
            <ModHeadersTable :headers="headers" />
            <ComercialFilterDialog @filterEvent="getFilterEvent($event)" />
        </v-card>
        <div id="finReportTable"></div>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { getWorkingDays, parseToFloatSpecialInteger } from '@/util/libUtil.js';

import ModHeadersTable from '@/components/GerenciaTeletrabajo/ComercialesTable/ModHeadersTable.vue';
import Dial from '@/components/GerenciaTeletrabajo/ReportTable/Dial.vue';
import DateFilterDialog from '@/components/GerenciaTeletrabajo/ReportTable/DateFilterDialog.vue';
import Legend from '@/components/GerenciaTeletrabajo/ComercialesTable/Legend.vue';
import ComercialFilterDialog from '@/components/GerenciaTeletrabajo/ReportTable/ComercialFilterDialog.vue';

export default {
	name: 'ReportTable',
	components: {
		ModHeadersTable,
		Dial,
		Legend,
		DateFilterDialog,
		ComercialFilterDialog,
	},
	data: () => ({
		footerProps: {
			disableItemsPerPage: true,
			itemsPerPageOptions: [20],
		},
		commercialWorkingDays: 0,
		commercialWorkingDaysUntilToday: 0,
		dialog: false,
		view: {
			viewPeso: {
				text: 'Peso',
				visualize: 'Peso',
				value: true,
			},
			viewObjCons: {
				text: 'Objetivo / Consecuencia',
				visualize: 'Obj/Cons',
				value: false,
			},
			viewObjConsPer: {
				text: 'Objetivo / Consecuencia %',
				visualize: '%Obj/%Cons',
				value: true,
			},
			viewFivePercent: {
				text: 'Proyección',
				visualize: 'Proyección',
				value: false,
			},
		},
		legend: [
			{
				title: 'Parametros',
				icon: 'mdi-tune-vertical-variant',
				text: 'Parametros que se pueden visualizar en cada uno de los objetivos, como son el peso, objetivo, consecución, proyección, etc',
			},
			{
				title: 'Peso',
				icon: 'mdi-dumbbell',
				text: 'Porcentaje de peso que representa el objetivo para el comercial',
			},
			{
				title: 'Objetivo',
				icon: 'mdi-target',
				text: 'Número de objetivos establecidos para el comercial',
			},
			{
				title: 'Consecución',
				icon: 'mdi-checkbox-marked-circle-plus-outline',
				text: 'Objetivos completados por el comercial',
			},
			{
				title: 'Proyección',
				icon: 'mdi-spotlight-beam',
				text: 'Número de objetivos que debería tener el comercial a día actual',
			},
			{
				title: 'Consecución total',
				icon: 'mdi-percent',
				text: 'Sumatoria de consecuciones de cada KPi, en totales se refleja la media total de todos los comerciales',
			},
			{
				title: 'Bolsa',
				icon: 'mdi-currency-usd',
				text: 'Bolsa generada por las ventas del comercial, si no tienen recompesa de bolsa fija o variable se asignara un circulo de color rojo y mostrará la bolsa en su totalidad',
			},
			{
				title: 'Bolsa proyección',
				icon: 'mdi-cash-multiple',
				text: 'Total de bolsa que proyecta el comercial cuando acabe el mes',
			},
			{
				title: 'Costo/Rentabilidad',
				icon: 'mdi-currency-eur-off',
				text: 'Gasto que supone el comercial para la empresa, versus la rentabilidad que se obtiene por la bolsa generada',
			},
			{
				title: 'Ofertas',
				icon: 'mdi-offer',
				text: 'Número de ofertas realizadas por el comercial',
			},
		],
		KPIs: [],
		headers: [
			{
				text: 'Nombre',
				value: 'comercial.nombreCompleto',
				sortable: true,
				show: true,
			},
			{
				text: 'Parametros',
				value: 'params',
				sortable: true,
				show: true,
			},
		],
	}),
	created() {
		this.calculateCommercialDays();
		if (this.objetivos.length == 0) {
			this.fetchObjetivo({});
			this.fetchBolsa({});
			this.getComercialesData({ newParams: this.returnNewParams });
		}
	},
	methods: {
		parseToFloatSpecialInteger,
		getXPropComercial(item, prop) {
			return this.getStatsComercial(item.comercial.id)
				? this.getStatsComercial(item.comercial.id)[prop]
				: 0;
		},
		customSort(items, index, isDesc) {
			index = index.length && index[0];
			isDesc = isDesc.length && isDesc[0];

			// generic sort function
			if (this.KPIs.includes(index)) {
				items.sort((a, b) => {
					return isDesc
						? b[index].consecucion - a[index].consecucion
						: a[index].consecucion - b[index].consecucion;
				});
			} else if (index == 'obj_consec_proyec') {
				items.sort((a, b) => {
					return isDesc
						? b.consecuciones - a.consecuciones
						: a.consecuciones - b.consecuciones;
				});
			} else if (index == 'bolsa') {
				items.sort((a, b) => {
					return isDesc
						? this.getBolsa(b.comercial.id) -
								this.getBolsa(a.comercial.id)
						: this.getBolsa(a.comercial.id) -
								this.getBolsa(b.comercial.id);
				});
			} else if (index == 'ofertas') {
				items.sort((a, b) => {
					return isDesc
						? this.getXPropComercial(b, 'num_ofertas') -
								this.getXPropComercial(a, 'num_ofertas')
						: this.getXPropComercial(a, 'num_ofertas') -
								this.getXPropComercial(b, 'num_ofertas');
				});
			} else if (index == 'consec_total_percent') {
				items.sort((a, b) => {
					return isDesc
						? b.consec_total_percent - a.consec_total_percent
						: a.consec_total_percent - b.consec_total_percent;
				});
			}

			return items;
		},
		rentabilidad(item) {
			return parseToFloatSpecialInteger(
				this.getBolsaRaw(item.comercial.id) -
					item.comercial.costoGeneral
			);
		},
		calculatePercentageError({ consecucion, five_percent }) {
			return (
				((consecucion - five_percent) / five_percent) *
				100
			).toFixed(2);
		},
		calculatePercentageErrorTotales({ consecuciones, five_percents }) {
			return (
				((consecuciones - five_percents) / five_percents) *
				100
			).toFixed(2);
		},
		itemRowBackgroundFivePercent: function (item, func) {
			let color = '';

			if (item.objetivos == 0) {
				color = 'azul';
			} else if (func(item) <= -6) {
				color = 'rojo';
			} else if (func(item) <= -1) {
				color = 'naranja';
			} else if (func(item) < 0) {
				color = 'amarillo';
			} else {
				color = 'verde';
			}

			return color;
		},
		isShowValueHeader(item) {
			return this.headers.find(({ value }) => value === item).show;
		},
		consecTotalPercent(item) {
			let value = 0;
			Object.keys(item).forEach((key) => {
				if (this.KPIs.includes(key)) {
					value += item[key].comision_porc;
				}
			});

			return parseToFloatSpecialInteger(value);
		},
		getStatsComercial(idComercial) {
			return this.comercialesInfo.find(({ id }) => id == idComercial);
		},
		calculateCommercialDays() {
			const dateDate = new Date(this.date);
			this.commercialWorkingDays = getWorkingDays(dateDate);
			if (dateDate < this.dateActualInmutable) {
				this.commercialWorkingDaysUntilToday = getWorkingDays(dateDate);
			} else {
				this.commercialWorkingDaysUntilToday = getWorkingDays(
					dateDate,
					true
				);
			}
		},
		getProyeccion(id) {
			const bolsa = this.getBolsa(id);
			if (bolsa == 0) {
				return 0;
			}

			return (
				(bolsa / this.commercialWorkingDaysUntilToday) *
				this.commercialWorkingDays
			).toFixed(2);
		},
		getBolsa(id) {
			const reward = this.getReward(id);

			const bolsaPorcentComercial =
				reward.reward?.amount * 0.01 * reward.bolsa;
			const bolsaPorcentRecomendado =
				reward.rewardRecomendado?.amount *
				0.01 *
				reward.bolsaRecomendado;
			const bolsaPorcent =
				bolsaPorcentComercial + bolsaPorcentRecomendado;

			if (bolsaPorcent) {
				return bolsaPorcent.toFixed(2);
			} else if (bolsaPorcentComercial) {
				return bolsaPorcentComercial.toFixed(2);
			} else {
				return (reward.bolsa + reward.bolsaRecomendado).toFixed(2);
			}
		},
		getBolsaRaw(id) {
			const reward = this.getReward(id);
			return (reward.bolsa + reward.bolsaRecomendado).toFixed(2);
		},
		getReward(id) {
			return this.rewards.find(({ comercialId }) => comercialId == id);
		},
		onClickChild(dateChild) {
			this.date = dateChild;
			this.fetchObjetivo({});
			this.fetchBolsa({});
			this.getComercialesData({ newParams: this.returnNewParams });
		},
		getFilterEvent(filterComercial) {
			this.filtersComercial = filterComercial;
			this.fetchObjetivo({});
			this.fetchBolsa({});
			this.getComercialesData({ newParams: this.returnNewParams });
		},
		...mapActions('reportTable', ['fetchObjetivo', 'fetchBolsa']),
		...mapActions('gerencia', ['getComercialesData']),
	},
	computed: {
		returnNewParams() {
			return {
				newDate: this.date,
				estado: this.filtersComercial
					? this.filtersComercial.estado
					: null,
				tipoComercial: this.filtersComercial
					? this.filtersComercial.tipoComercial
					: null,
			};
		},
		onlyKPIinHeaderVisible() {
			return this.KPIs.filter((kpi) =>
				this.headers.find(
					(header) => header.value === kpi && header.show
				)
			);
		},
		totalesResumen() {
			if (
				!this.rewards.length ||
				!this.objetivosProcess.length ||
				!this.KPIs.length
			) {
				return {};
			}

			let bolsaTotal = this.rewards.reduce((acc, reward) => {
				return acc + reward.bolsa;
			}, 0);

			let bolsaTotalPercent =
				(bolsaTotal / this.commercialWorkingDaysUntilToday) *
				this.commercialWorkingDays;

			let rentabilidad = 0;
			this.rewards.forEach((reward) => {
				const comercial = this.objetivosProcess.find(
					(obj) => obj.comercial.id == reward.comercialId
				);
				rentabilidad +=
					reward.bolsa +
					reward.bolsaRecomendado -
					(comercial
						? parseFloat(comercial.comercial.costoGeneral ?? 0)
						: 0);
			});

			let numOfertas = this.comercialesInfo.reduce((acc, comercial) => {
				return acc + comercial.num_ofertas;
			}, 0);

			let objetivosTotales = {};
			this.objetivosProcess.forEach((obj) => {
				this.KPIs.forEach((kpi) => {
					// check if objetivosTotales has the key
					if (!objetivosTotales[kpi]) {
						objetivosTotales[kpi] = {
							objetivo: 0,
							consecucion: 0,
						};
					}
					objetivosTotales[kpi].objetivo += obj[kpi]
						? obj[kpi].objetivo
						: 0;
					objetivosTotales[kpi].consecucion += obj[kpi]
						? obj[kpi].consecucion
						: 0;
				});
			});

			// Loop over objetivosTotales
			Object.keys(objetivosTotales).forEach((key) => {
				objetivosTotales[key].five_percent = Math.round(
					(objetivosTotales[key].objetivo /
						this.commercialWorkingDaysUntilToday) *
						this.commercialWorkingDays
				);
			});

			// Reduce
			let consecTotalComercialesPercent = this.objetivosProcess.reduce(
				(acc, obj) => {
					return acc + this.consecTotalPercent(obj);
				},
				0
			);
			consecTotalComercialesPercent /= this.objetivosProcess.length;

			// Move objetivosTotales
			let objetivos = 0;
			let consecuciones = 0;
			Object.keys(objetivosTotales).forEach((key) => {
				objetivos += objetivosTotales[key].objetivo;
				consecuciones += objetivosTotales[key].consecucion;
			});

			// Calculate five_percent
			let five_percents = Math.round(
				(objetivos / this.commercialWorkingDays) *
					this.commercialWorkingDaysUntilToday
			);

			return {
				consecTotalPercent: consecTotalComercialesPercent.toFixed(2),
				bolsaTotal: bolsaTotal.toFixed(2),
				bolsaTotalPercent: bolsaTotalPercent.toFixed(2),
				rentabilidad: rentabilidad.toFixed(2),
				objetivos: objetivos,
				consecuciones: consecuciones,
				five_percents: five_percents,
				numOfertas,
				objetivosTotales,
			};
		},
		objetivosProcess() {
			if (this.objetivos.length > 0) {
				if (!this.objetivos[0].hasOwnProperty('objetivo_porc')) {
					this.definePropertyObjetivos(this.objetivos);
				}

				// Get in array all comercial, without repetitions
				const comercialIds = [
					...new Set(
						this.objetivos.map((objetivo) => objetivo.comercial.id)
					),
				];

				let arrayComercialReport = [];
				comercialIds.forEach((comercialId) => {
					const objetivosComercial = this.objetivos.filter(
						(objetivo) => objetivo.comercial.id === comercialId
					);

					let object = {
						comercial: objetivosComercial[0].comercial,
						objetivos: 0,
						consecuciones: 0,
						five_percents: 0,
					};

					objetivosComercial.forEach((objetivo) => {
						if (!this.KPIs.includes(objetivo.familia.id)) {
							this.KPIs.push(objetivo.familia.id);
						}
						object[objetivo.familia.id] = {
							peso: objetivo.peso,
							objetivo: objetivo.objetivo,
							consecucion: objetivo.consecucion,
							objetivo_porc: objetivo.objetivo_porc,
							comision_porc: objetivo.comision_porc,
							five_percent: objetivo.five_percent,
						};
						object.objetivos += objetivo.objetivo;
						object.consecuciones += objetivo.consecucion;
					});
					// Calculate five_percent
					object.five_percents = Math.round(
						(object.objetivos / this.commercialWorkingDays) *
							this.commercialWorkingDaysUntilToday
					);
					arrayComercialReport.push(object);
				});

				arrayComercialReport.forEach((item) => {
					item['consec_total_percent'] =
						this.consecTotalPercent(item);
				});

				// Sort alphabetically KPIs
				this.KPIs.sort((a, b) => {
					if (a < b) {
						return -1;
					}
					if (a > b) {
						return 1;
					}
					return 0;
				});

				return arrayComercialReport;
			} else {
				this.KPIs = [];
				return [];
			}
		},
		filtersComercial: {
			get() {
				return this.$store.state.reportTable.reportTable
					.filtersComercial;
			},
			set(value) {
				this.$store.commit('reportTable/filtersComercial', value);
			},
		},
		date: {
			get() {
				return this.$store.state.reportTable.reportTable.date;
			},
			set(value) {
				this.$store.commit('reportTable/date', value);
			},
		},
		...mapState('reportTable', {
			dateActualInmutable: (state) => state.dateActualInmutable,
			isLoadingObjetivos: (state) => state.reportTable.isLoadingObjetivos,
			isloadingRewards: (state) => state.reportTable.isloadingRewards,
			objetivos: (state) => state.reportTable.objetivos,
			rewards: (state) => state.reportTable.rewards,
		}),
		...mapState('util', {
			search: (state) => state.navBarSearchField,
		}),
		...mapState('gerencia', {
			comercialesInfo: (state) => state.comercialesInfo,
			isLoadingInfo: (state) => state.isLoadingInfo,
		}),
		...mapGetters('reportTable', ['definePropertyObjetivos']),
	},
	watch: {
		date: {
			handler(val) {
				if (val) {
					this.calculateCommercialDays();
				}
			},
			immediate: true,
		},
		KPIs: {
			immediate: true,
			handler() {
				// Delete all headers except the first one
				this.headers = [
					{
						text: 'Nombre',
						value: 'comercial.nombreCompleto',
						sortable: false,
						show: true,
					},
					{
						text: 'Parametros',
						value: 'params',
						sortable: false,
						show: true,
					},
				];

				// Add KPIs to headers, only if not exists in headers
				this.KPIs.forEach((KPI) => {
					if (!this.headers.find((header) => header.value === KPI)) {
						this.headers.push({
							text: KPI.replaceAll('_', ' '),
							value: KPI,
							sortable: true,
							align: 'center',
							show: true,
						});
					}
				});

				this.headers.push({
					text: 'Total Objetivo/Consecución/Proyección',
					value: 'obj_consec_proyec',
					sortable: true,
					align: 'center',
					show: true,
				});
				this.headers.push({
					text: 'Consecución total',
					value: 'consec_total_percent',
					sortable: true,
					align: 'center',
					show: true,
				});
				this.headers.push({
					text: 'Bolsa',
					value: 'bolsa',
					sortable: true,
					align: 'center',
					show: true,
				});
				this.headers.push({
					text: 'Bolsa Proyección',
					value: 'bolsa_proyeccion',
					sortable: false,
					align: 'center',
					show: true,
				});
				this.headers.push({
					text: 'Costo/Rentabilidad',
					value: 'rentabilidad',
					sortable: false,
					align: 'center',
					show: true,
				});
				this.headers.push({
					text: 'Ofertas',
					value: 'ofertas',
					sortable: true,
					align: 'center',
					show: true,
				});
			},
		},
	},
};
</script>

<style>
.verde {
	background-color: rgb(182, 251, 182);
}

.rojo {
	background-color: rgb(253, 175, 175);
}

.naranja {
	background-color: rgb(255, 217, 147);
}

.amarillo {
	background-color: rgb(254, 252, 140);
}

.azul {
	background-color: #baccff;
}
</style>